import StageListPage from './list/'
import StageAddPage from './add/'
import StageViewPage from './view/'

export default {
  StageListPage,
  StageViewPage,
  StageAddPage
}
